import React from "react";
import Services from "../components/Services/Services";

const ServicesPage: React.FC = () => {
  return (
    <div className="min-h-screen">
      <div className="pt-16 sm:pt-20" />
      <Services />
    </div>
  );
};

export default ServicesPage; 